import React, { memo } from 'react'
import { Grid } from '@mui/material'

import ClaimCard from './ClaimCard'

const ClaimCards = ({ t, onClickClaim, claimActionProps, mainProfile }) => {
  const { contractsForClaim } = mainProfile
  return contractsForClaim.map((contract) => {
    return (
      <Grid key={contract.id} item xs={12}>
        <ClaimCard
          t={t}
          onClickClaim={() => onClickClaim(contract)}
          {...claimActionProps}
          {...contract}
        />
      </Grid>
    )
  })
}

export default memo(ClaimCards)
